module.exports = __webpack_public_path__ + "img/mkb.c5031383.png";